import { Component } from 'react';

// Si una pantalla falla, se muestra un aviso en lugar de una página en blanco.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Error de pantalla', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="bg-[#060d1b] min-h-screen flex items-center justify-center px-6" role="alert">
        <div className="max-w-md text-center space-y-4">
          <p className="text-white text-lg font-semibold">Algo no ha ido bien en esta pantalla</p>
          <p className="text-sm text-gray-400">Recarga la página. Si vuelve a pasar, escríbenos y lo revisamos.</p>
          <button type="button" onClick={() => window.location.reload()}
            className="rounded-xl bg-[#c9a84c] px-5 py-2.5 text-sm font-semibold text-[#0a1628]">Recargar</button>
        </div>
      </div>
    );
  }
}
